<template>
    <div class="a-flex-cfsc">
        <div id="myChartCar" class="a-flex-1 a-w-100"></div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            lineChartCar: null,
            startTime: '',
            endTime: '',
            option: {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    },
                },
                legend: {
                    textStyle:{
                        color: '#ffffff'
                    },
                    itemGap: 40,
                    y: 'bottom',
                },
                grid: {
                    left: '1%',
                    right: '4%',
                    bottom: '15%',
                    top: '5%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        boundaryGap: false,
                        data: []
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        splitLine: {
                            lineStyle: {
                                color: '#444444',
                                width: 0
                            }
                        }
                    },{
                        type: 'value',
                        splitLine: {
                            lineStyle: {
                                color: '#444444',
                                width: 0
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: '当前车辆',
                        yAxisIndex: 1,
                        type: 'line',
                        data: [],
                        smooth: true,
                        areaStyle:{
                            origin:'start',
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0, color: '#9014EE' // 0% 处的颜色
                                }, {
                                    offset: 1, color: '#05B5CD' // 100% 处的颜色
                                }],
                                global: false // 缺省为 false
                            },
                            opacity: 0.05
                        },
                        lineStyle:{
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0, color: '#9014EE' // 0% 处的颜色
                                }, {
                                    offset: 1, color: '#05B5CD' // 100% 处的颜色
                                }],
                                global: false, // 缺省为 false
                            },
                            width: 2
                        },
                        symbolSize: [24,24],
                        symbol: 'image://https://sxwhapp.oss-cn-beijing.aliyuncs.com/TZ/dev/cate/3594678980854409b385c15df22bf5c3.png',
                        emphasis:{
                            itemStyle:{
                                // borderColor: '#05B5CD',
                                opacity:1,
                            },
                            lineStyle:{
                                width: 3
                            }
                        },
                        itemStyle:{
                            color: '#05B5CD',
                        },
                        showSymbol: false
                    },
                    {
                        name: '历史车辆',
                        type: 'line',
                        smooth: true,
                        areaStyle:{
                            origin:'start',
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0, color: '#FAD961' // 0% 处的颜色
                                }, {
                                    offset: 1, color: '#F76B1C' // 100% 处的颜色
                                }],
                                global: false // 缺省为 false
                            },
                            opacity: 0.05
                        },
                        lineStyle:{
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0, color: '#FAD961' // 0% 处的颜色
                                }, {
                                    offset: 1, color: '#F76B1C' // 100% 处的颜色
                                }],
                                global: false, // 缺省为 false
                            },
                            width: 2
                        },
                        symbolSize: [24,24],
                        symbol: 'image://https://sxwhapp.oss-cn-beijing.aliyuncs.com/TZ/dev/cate/abcb8e390dcc44978a1ba48149b90c94.png',
                        emphasis:{
                            itemStyle:{
                                opacity:1
                            },
                            lineStyle:{
                                width: 3
                            }
                        },
                        itemStyle:{
                            color: '#FAD961',
                        },
                        showSymbol: false,
                        data: []
                    }
                ]
            }
        };
    },

    mounted() {
        this.startTime = this.$getDay.getTodayBeforeDays(30,'YYYY-MM-DD HH:mm:ss')
        this.endTime = this.$getDay.getToday('YYYY-MM-DD HH:mm:ss')
        let _this = this
        _this.$nextTick(_ => {   
            _this.drawLine()
            window.addEventListener("resize", function() {        
                _this.lineChartCar.resize();     
            });
        });
    },
    beforeDestroy () {
        window.removeEventListener("resize", ()=>{});
    },
    methods: {
        drawLine(){
            // 基于准备好的dom，初始化echarts实例
            this.lineChartCar = this.$echarts.init(document.getElementById('myChartCar'))

            // 绘制图表
            this.$Axios._post({
                url: this.$Config.apiUrl.bikeTrends,
                method: "post",
                params: {
                    startTime:this.startTime,
                    endTime:this.endTime
                }
            }).then(res => {
                if(res.result.code == 0){                        
                    let xAxis = []
                    let data1 = []
                    let data2 = []
                    res.result.data.map(item=>{
                        xAxis.push(item.day)
                        data1.push(item.current)
                        data2.push(item.history)
                    })
                    this.option.xAxis[0].data = xAxis
                    this.option.series[0].data = data1
                    this.option.series[1].data = data2
                    this.lineChartCar.setOption(this.option,true);
                    // this.lineChartCar.resize();
                }else{
                    this.$message.error(res.result.message)
                }
            })
            
        },
    },
};
</script>
<style lang="scss" scoped>

</style>